<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title>
      <span class="text-xl text-gray-700 font-bold">
      Gerenciamento do Fornecedor
      </span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
  <div class="mt-5">
    <ng-template #dataFornecedor>
    <div class="card-style shadow radius mx-2 gap-4 px-8 py-6 mt-5">
      <div>
        <span class="text-xl text-gray-700 font-bold">Fornecedor</span>
      </div>
      <div [formGroup]="form" class="flex w-full justify-center text-center text-2xl font-medium gap-4 items-center mt-4">
        <mat-form-field hintLabel class="input-tg w-4/12" appearance="outline">
          <mat-label>
            Nome
          </mat-label>
          <input type="text" matInput formControlName="nome" disabledInteractive [readOnly]="true">
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12"  appearance="outline">
          <mat-label>
            Razão Social
          </mat-label>
          <input type="text" matInput formControlName="razao_social" disabledInteractive [readOnly]="true" >
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>
            CNPJ
          </mat-label>
          <input type="text" formControlName="cnpj" matInput disabledInteractive [readOnly]="true">
        </mat-form-field>
      </div>
    </div>
    </ng-template>

    <mat-tab-group animationDuration="400ms">
   <mat-tab [labelClass]="'py-3'" label="Motorista">
     <ng-container class="mt-5" *ngTemplateOutlet="dataFornecedor" />
      <driver-supplier-management [supplierId]="data.item.pessoa_id" ></driver-supplier-management>
      </mat-tab>
      <mat-tab
        [labelClass]="'py-3'"
        label="Responsável">
        <ng-container class="mt-5" *ngTemplateOutlet="dataFornecedor" />
        <responsible-supplier-management [supplierId]="data.item.pessoa_id"></responsible-supplier-management>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="flex mt-4 mx-1 justify-end">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      (click)="close()"
    >
      Fechar
    </button>
  </div>
  </mat-card-content>

</mat-card>
